export const featuredSitters = [
  {
    id: 1,
    name: "田中 美咲",
    city: "ロンドン",
    country: "イギリス",
    vatRegistered: false,
    introduction: "犬と猫、両方の経験が豊富です。10年以上ペットと暮らしています。",
    profileImage: "https://public.readdy.ai/ai/img_res/a5496ec79f70e5c4825d9f594d0bfb35.jpg",
    pricePerVisit: 25,
    rating: 4.9,
    reviewCount: 47,
    verified: true,
    services: ["散歩", "訪問ケア", "お泊まり"],
    experience: "5年以上",
    pets: ["犬", "猫"]
  },
  {
    id: 2,
    name: "佐藤 健太",
    city: "シドニー",
    country: "オーストラリア",
    vatRegistered: false,
    introduction: "大型犬の散歩が得意です。毎日公園で一緒に遊びます。",
    profileImage: "https://readdy.ai/api/search-image?query=japanese-man-walking-with-large-dog-in-park-sunny-day-active-lifestyle-professional-pet-sitter-clean-simple-background-warm-natural-light&width=400&height=500&seq=sitter2&orientation=portrait",
    pricePerVisit: 30,
    rating: 4.8,
    reviewCount: 32,
    verified: true,
    services: ["散歩", "訪問ケア", "タクシー送迎"],
    experience: "3年以上",
    pets: ["犬"]
  },
  {
    id: 3,
    name: "山田 愛子",
    city: "バンクーバー",
    country: "カナダ",
    vatRegistered: false,
    introduction: "猫専門のシッターです。お留守番中も安心してお任せください。",
    profileImage: "https://readdy.ai/api/search-image?query=japanese-woman-holding-cute-cat-in-cozy-home-interior-gentle-caring-atmosphere-professional-pet-care-clean-simple-background-soft-natural-lighting&width=400&height=500&seq=sitter3&orientation=portrait",
    pricePerVisit: 22,
    rating: 5.0,
    reviewCount: 28,
    verified: true,
    services: ["訪問ケア", "お泊まり"],
    experience: "4年以上",
    pets: ["猫"]
  },
  {
    id: 4,
    name: "鈴木 大輔",
    city: "ニューヨーク",
    country: "アメリカ",
    vatRegistered: false,
    introduction: "小型犬から大型犬まで対応可能です。獣医師免許保有。",
    profileImage: "https://readdy.ai/api/search-image?query=professional-japanese-man-with-small-dog-and-large-dog-veterinary-background-trustworthy-caring-atmosphere-clean-simple-background-bright-natural-light&width=400&height=500&seq=sitter4&orientation=portrait",
    pricePerVisit: 35,
    rating: 4.9,
    reviewCount: 56,
    verified: true,
    services: ["散歩", "訪問ケア", "お泊まり", "タクシー送迎"],
    experience: "8年以上",
    pets: ["犬", "猫"]
  },
  {
    id: 5,
    name: "高橋 さくら",
    city: "パリ",
    country: "フランス",
    vatRegistered: false,
    introduction: "小型犬と猫のケアが得意です。お薬の投与も対応できます。",
    profileImage: "https://readdy.ai/api/search-image?query=japanese-woman-with-small-dog-and-cat-together-caring-gentle-atmosphere-professional-pet-sitter-clean-simple-background-warm-soft-lighting&width=400&height=500&seq=sitter5&orientation=portrait",
    pricePerVisit: 28,
    rating: 4.7,
    reviewCount: 41,
    verified: true,
    services: ["訪問ケア", "お泊まり"],
    experience: "6年以上",
    pets: ["犬", "猫"]
  },
  {
    id: 6,
    name: "中村 翔",
    city: "シンガポール",
    country: "シンガポール",
    vatRegistered: false,
    introduction: "活発な犬の散歩とトレーニングが得意です。",
    profileImage: "https://readdy.ai/api/search-image?query=energetic-japanese-man-running-with-active-dog-outdoor-park-setting-professional-dog-trainer-clean-simple-background-bright-daylight&width=400&height=500&seq=sitter6&orientation=portrait",
    pricePerVisit: 26,
    rating: 4.8,
    reviewCount: 35,
    verified: true,
    services: ["散歩", "訪問ケア", "タクシー送迎"],
    experience: "4年以上",
    pets: ["犬"]
  }
];

export const allSitters = [
  ...featuredSitters,
  {
    id: 7,
    name: "西村 朋子",
    city: "メルボルン",
    country: "オーストラリア",
    vatRegistered: false,
    introduction: "ウサギや小動物のケアも得意です。安心・丁寧なお世話をお約束します。",
    profileImage: "https://readdy.ai/api/search-image?query=gentle-japanese-woman-holding-small-rabbit-cozy-home-setting-professional-pet-sitter-clean-white-background-natural-warm-lighting&width=400&height=500&seq=sitter7&orientation=portrait",
    pricePerVisit: 24,
    rating: 4.9,
    reviewCount: 22,
    verified: true,
    services: ["訪問ケア", "お泊まり"],
    experience: "3年以上",
    pets: ["猫", "小動物"]
  },
  {
    id: 8,
    name: "岡田 雄一",
    city: "トロント",
    country: "カナダ",
    vatRegistered: false,
    introduction: "元ドッグトレーナー。しつけ相談も受け付けています。",
    profileImage: "https://readdy.ai/api/search-image?query=confident-japanese-man-with-trained-dog-sitting-obediently-professional-trainer-clean-background-bright-studio-light&width=400&height=500&seq=sitter8&orientation=portrait",
    pricePerVisit: 32,
    rating: 4.8,
    reviewCount: 39,
    verified: true,
    services: ["散歩", "訪問ケア", "お泊まり"],
    experience: "7年以上",
    pets: ["犬"]
  },
  {
    id: 9,
    name: "小川 明日香",
    city: "フランクフルト",
    country: "ドイツ",
    vatRegistered: true,
    introduction: "ドイツ在住8年。ペットホテルでの勤務経験があります。",
    profileImage: "https://readdy.ai/api/search-image?query=japanese-woman-with-dog-in-european-style-home-interior-comfortable-warm-atmosphere-professional-pet-care-clean-background&width=400&height=500&seq=sitter9&orientation=portrait",
    pricePerVisit: 27,
    rating: 4.7,
    reviewCount: 18,
    verified: true,
    services: ["訪問ケア", "お泊まり", "タクシー送迎"],
    experience: "5年以上",
    pets: ["犬", "猫"]
  },
  {
    id: 10,
    name: "藤田 隆",
    city: "ロサンゼルス",
    country: "アメリカ",
    vatRegistered: false,
    introduction: "大型犬が大好きです。広い庭つきのお宅でお預かりします。",
    profileImage: "https://readdy.ai/api/search-image?query=japanese-man-with-large-dog-in-spacious-backyard-garden-sunny-california-setting-professional-caring-clean-background&width=400&height=500&seq=sitter10&orientation=portrait",
    pricePerVisit: 38,
    rating: 4.9,
    reviewCount: 29,
    verified: true,
    services: ["散歩", "お泊まり"],
    experience: "6年以上",
    pets: ["犬"]
  },
  {
    id: 11,
    name: "石川 美穂",
    city: "アムステルダム",
    country: "オランダ",
    vatRegistered: true,
    introduction: "オランダ在住。猫中心ですが犬も対応可能です。",
    profileImage: "https://readdy.ai/api/search-image?query=japanese-woman-with-cat-in-amsterdam-canal-house-interior-cozy-european-home-professional-pet-sitter-warm-soft-lighting&width=400&height=500&seq=sitter11&orientation=portrait",
    pricePerVisit: 26,
    rating: 5.0,
    reviewCount: 15,
    verified: true,
    services: ["訪問ケア", "お泊まり"],
    experience: "2年以上",
    pets: ["猫", "犬"]
  },
  {
    id: 12,
    name: "松田 誠",
    city: "ベルリン",
    country: "ドイツ",
    vatRegistered: false,
    introduction: "犬の行動学を勉強中。丁寧で穏やかなケアが得意です。",
    profileImage: "https://readdy.ai/api/search-image?query=calm-japanese-man-sitting-relaxed-with-dog-on-sofa-european-apartment-interior-professional-caring-clean-background-warm-light&width=400&height=500&seq=sitter12&orientation=portrait",
    pricePerVisit: 29,
    rating: 4.8,
    reviewCount: 21,
    verified: true,
    services: ["散歩", "訪問ケア"],
    experience: "3年以上",
    pets: ["犬"]
  },
  {
    id: 13,
    name: "河野 裕子",
    city: "香港",
    country: "香港",
    vatRegistered: false,
    introduction: "アジア在住長く、猫のお留守番ケアが専門です。",
    profileImage: "https://readdy.ai/api/search-image?query=japanese-woman-with-two-cats-in-modern-apartment-city-view-background-professional-pet-care-clean-calm-atmosphere-warm-light&width=400&height=500&seq=sitter13&orientation=portrait",
    pricePerVisit: 31,
    rating: 4.9,
    reviewCount: 33,
    verified: true,
    services: ["訪問ケア", "お泊まり"],
    experience: "5年以上",
    pets: ["猫"]
  },
  {
    id: 14,
    name: "青木 洋介",
    city: "チューリッヒ",
    country: "スイス",
    vatRegistered: false,
    introduction: "山が好きなシッター。大型犬との長距離散歩が得意です。",
    profileImage: "https://readdy.ai/api/search-image?query=athletic-japanese-man-hiking-with-large-dog-mountain-trail-scenic-nature-background-professional-active-pet-sitter-clean-outdoor&width=400&height=500&seq=sitter14&orientation=portrait",
    pricePerVisit: 45,
    rating: 4.7,
    reviewCount: 12,
    verified: false,
    services: ["散歩", "お泊まり"],
    experience: "2年以上",
    pets: ["犬"]
  },
  {
    id: 15,
    name: "伊藤 なな",
    city: "ロッテルダム",
    country: "オランダ",
    vatRegistered: false,
    introduction: "ロッテルダム在住3年。犬の散歩と訪問ケアを丁寧に対応します。小型犬が特に得意です。",
    profileImage: "https://readdy.ai/api/search-image?query=japanese-woman-smiling-with-small-dog-in-modern-dutch-apartment-interior-bright-clean-background-natural-daylight-warm-atmosphere-professional-pet-sitter&width=400&height=500&seq=sitter15&orientation=portrait",
    pricePerVisit: 25,
    rating: 4.8,
    reviewCount: 11,
    verified: true,
    services: ["散歩", "訪問ケア"],
    experience: "2年以上",
    pets: ["犬"]
  },
  {
    id: 16,
    name: "村上 けい",
    city: "ユトレヒト",
    country: "オランダ",
    vatRegistered: true,
    introduction: "ユトレヒト大学近くに住んでいます。猫のお留守番・投薬対応も可能です。",
    profileImage: "https://readdy.ai/api/search-image?query=japanese-woman-gently-holding-orange-cat-in-cozy-european-home-utrecht-style-interior-warm-natural-light-professional-pet-care-clean-calm-background&width=400&height=500&seq=sitter16&orientation=portrait",
    pricePerVisit: 24,
    rating: 4.9,
    reviewCount: 9,
    verified: true,
    services: ["訪問ケア", "お泊まり"],
    experience: "1年以上",
    pets: ["猫"]
  },
  {
    id: 17,
    name: "橋本 りょう",
    city: "アムステルダムフェーン",
    country: "オランダ",
    vatRegistered: false,
    introduction: "アルメーレ（アムステルダムフェーン）在住。広い公園近くで犬の散歩が充実しています。",
    profileImage: "https://readdy.ai/api/search-image?query=japanese-man-outdoor-walking-with-energetic-dog-netherlands-park-greenery-background-bright-natural-light-professional-pet-sitter-clean-casual-atmosphere&width=400&height=500&seq=sitter17&orientation=portrait",
    pricePerVisit: 23,
    rating: 4.7,
    reviewCount: 7,
    verified: true,
    services: ["散歩", "訪問ケア", "お泊まり"],
    experience: "1年以上",
    pets: ["犬"]
  },
  {
    id: 18,
    name: "坂本 ゆか",
    city: "デュッセルドルフ",
    country: "ドイツ",
    vatRegistered: true,
    introduction: "デュッセルドルフ日本人街近くに在住。日本人コミュニティとの繋がりが豊富で安心してお任せください。",
    profileImage: "https://readdy.ai/api/search-image?query=cheerful-japanese-woman-with-fluffy-dog-in-bright-modern-german-apartment-interior-clean-white-background-warm-natural-lighting-professional-caring-pet-sitter&width=400&height=500&seq=sitter18&orientation=portrait",
    pricePerVisit: 28,
    rating: 4.9,
    reviewCount: 14,
    verified: true,
    services: ["散歩", "訪問ケア", "お泊まり", "タクシー送迎"],
    experience: "3年以上",
    pets: ["犬", "猫"]
  }
];

export const cities = [
  "ロンドン",
  "シドニー",
  "バンクーバー",
  "ニューヨーク",
  "パリ",
  "シンガポール",
  "メルボルン",
  "トロント",
  "フランクフルト",
  "ロサンゼルス",
  "アムステルダム",
  "アムステルダムフェーン",
  "ロッテルダム",
  "ユトレヒト",
  "ベルリン",
  "デュッセルドルフ",
  "香港",
  "チューリッヒ"
];

export const citiesByCountry = [
  {
    country: "オランダ",
    cities: ["アムステルダム", "アムステルダムフェーン", "ロッテルダム", "ユトレヒト"]
  },
  {
    country: "ドイツ",
    cities: ["デュッセルドルフ", "フランクフルト"]
  }
];

export const services = [
  { id: "walk", name: "散歩", icon: "ri-walk-line" },
  { id: "visit", name: "訪問ケア", icon: "ri-home-heart-line" },
  { id: "boarding", name: "お泊まり", icon: "ri-hotel-bed-line" },
  { id: "taxi", name: "タクシー送迎", icon: "ri-taxi-line" }
];